import {
  Box,
  Table,
  TableBody,
  TableCell as MuiTableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { tableCellClasses } from "@mui/material/TableCell";
import { useTemplate } from "containers/templateDetail/store";
import head from "lodash/head";
import * as React from "react";
import UnitSwitch from "./unitSwitch";

const TableCell = styled(MuiTableCell)(({ theme }) => ({
  fontSize: theme.typography.body2.fontSize,
  border: "1px solid",
  borderColor: theme.palette.grey[300],
  padding: "8px 8px",
  textAlign: "center",
  whiteSpace: "nowrap",
  [`&.${tableCellClasses.body}`]: {
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.text.secondary,
  },
  [`&.${tableCellClasses.head}`]: {
    fontWeight: theme.typography.fontWeightSemiBold,
    color: theme.palette.text.primary,
  },
}));

export default function Chart(): React.ReactElement {
  const { sizes } = useTemplate();
  const [unit, setUnit] = React.useState<"CM" | "IN">("CM");

  const headStrs = React.useMemo(() => {
    const arr = ["Size"];

    const headSize: any = head(sizes);

    if (headSize) {
      for (let i = 0; i < headSize.attributes.length; i++) {
        const attribute = headSize.attributes[i];
        arr.push(attribute.name);
      }
    }

    return arr;
  }, [sizes]);

  const bodyStrArr = React.useMemo(() => {
    const arr = [];

    for (let i = 0; i < sizes.length; i++) {
      const size = sizes[i];
      const bodyStr = [size.name];
      for (let j = 0; j < size.attributes.length; j++) {
        const attribute = size.attributes[j];
        bodyStr.push(unit === "CM" ? attribute.cm_value : attribute.inch_value);
      }
      arr.push(bodyStr);
    }

    return arr;
  }, [sizes, unit]);

  return (
    <Box sx={{ mb: 2 }}>
      <UnitSwitch unit={unit} setUnit={setUnit} />
      <Box
        sx={{
          width: "100%",
          overflowX: "auto",
        }}
      >
        <Table>
          <TableHead>
            <TableRow>
              {headStrs.map((item, index) => {
                return <TableCell key={index}>{item}</TableCell>;
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {bodyStrArr.map((bodyStr, i) => {
              return (
                <tr key={`line-${i}`}>
                  {bodyStr.map((item, j) => (
                    <TableCell
                      key={`value-${j}`}
                      className={j === 0 ? tableCellClasses.head : null}
                    >
                      {item}
                    </TableCell>
                  ))}
                </tr>
              );
            })}
          </TableBody>
        </Table>
      </Box>
    </Box>
  );
}
